// extracted by mini-css-extract-plugin
module.exports = {"List":"AdditionalDndPanel_List__3GHMP","Item":"AdditionalDndPanel_Item__2TWz5"};